/**
 * description:
 * Photo Gallery page — fetches FASA event albums from the API and displays
 * them as a masonry grid of cards linking out to each Google Drive album.
 */
import { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import GalleryLayout from "./GalleryLayout";
import PageHero from "../../../utils/PageHero";
import galleryHero from "../../../pictures/Hero/GalleryHero.svg";

function GalleryPage() {
  const [picturesData, setPicturesData] = useState([]);
  const [loadingPictures, setLoadingPictures] = useState(true);

  // Fetch pictures data
  useEffect(() => {
    fetch("https://nehr0pj0y1.execute-api.us-east-1.amazonaws.com/fasa-events")
      .then((response) => response.json())
      .then((data) => {
        setPicturesData(data);
        setLoadingPictures(false);
      })
      .catch((error) => {
        console.error(error);
        setLoadingPictures(false);
      });
  }, []);

  if (loadingPictures) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <PageHero
        image={galleryHero}
        viewBoxWidth={1016}
        viewBoxHeight={313}
        cropHeight={313}
        bandColor="#224541"
        accessibleTitle="The Gallery!"
        width={{ xs: "94vw", sm: "620px", md: "889px" }}
        imageScale={0.81}
      />

      <Box sx={{ bgcolor: "background.default", px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "80px" } }}>
        <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
          <GalleryLayout events={picturesData} />
        </Box>
      </Box>
    </>
  );
}

export default GalleryPage;
